
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home/Home'
import './App.css';
import './i18n';
import Contact from './pages/Contact/Contact';
import Rooms from './pages/Rooms/Rooms';
import Terms from './pages/Terms/Terms';
import About from './pages/About/About';
import Gallery from './pages/Gallery/Gallery';

const App = () => {
   return (
      <>
         <Routes>
            <Route path="/" element={<Home />} />
            <Route path='/contact' element={<Contact />}></Route>
            <Route path='/rooms' element={<Rooms />}></Route>
            <Route path='/terms' element={<Terms />}></Route>
            <Route path='/about' element={<About />}></Route>
            <Route path='/gallery' element={<Gallery />}></Route>
         </Routes>
      </>
   );
};
export default App;

